function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'element-ui/lib/theme-chalk/display.css';
import { getTemp, importCardApi } from '@/api/enterprise';
import exportExcel from '@/components/common/exportExcel';
import importExcel from '@/components/common/importExcel';
import oaFromBox from '@/components/common/oaFromBox';
import 'animate.css';
import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
export default {
  name: 'FormBox',
  components: {
    importExcel: importExcel,
    exportExcel: exportExcel,
    oaFromBox: oaFromBox
  },
  props: {
    notEmployees: {
      type: String
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      departmentShow: false,
      pickerOptions: this.$pickerOptionsTimeEle,
      showForm: false,
      showText: '展开',
      distinguish: 2,
      columnNumber: 4,
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 140
        }, {
          wpx: 120
        }]
      },
      saveName: '',
      timeVal: [],
      isViewSearch: true,
      dropdownList: [{
        label: '导出',
        value: 1
      }, {
        label: '导入',
        value: 2
      }, {
        label: '下载模板',
        value: 3
      }],
      search: [],
      sexOptions: [{
        name: this.$t('toptable.all'),
        value: ''
      }, {
        name: this.$t('toptable.unknown'),
        value: '0'
      }, {
        name: this.$t('toptable.male'),
        value: '1'
      }, {
        name: this.$t('toptable.female'),
        value: '2'
      }],
      educationOptions: [{
        name: '研究生',
        value: 6
      }, {
        name: '本科',
        value: 5
      }, {
        name: '专科',
        value: 4
      }, {
        name: '高中及以下',
        value: 2
      }],
      timeSearch: [{
        name: '创建时间',
        value: 'createTime'
      }, {
        name: '修改时间',
        value: 'editTime'
      }],
      viewSearch: [{
        field: 'sex',
        title: '员工性别',
        type: 'select',
        options: []
      }, {
        field: 'education',
        title: '学历',
        type: 'select',
        options: this.educationOptions
      }, {
        field: 'status',
        title: '账号状态',
        type: 'select',
        options: [{
          name: this.$t('toptable.all'),
          value: ''
        }, {
          name: this.$t('toptable.normal'),
          value: 1
        }, {
          name: '停用',
          value: 2
        }, {
          name: '未激活',
          value: '0'
        }]
      }, {
        field: 'type',
        title: '员工状态',
        type: 'select',
        options: [{
          name: '全部',
          value: ''
        }, {
          name: '正式',
          value: 1
        }, {
          name: '试用',
          value: 2
        }]
      }],
      tableFrom: {
        time: '',
        sex: '',
        field: '',
        search: '',
        status: '',
        frame_id: '',
        types: [],
        education: '',
        exportType: 0
      },
      // 员工类型
      identityOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '正式',
        value: 1
      }, {
        label: '试用',
        value: 2
      }],
      activeDepartment: {},
      openStatus: false,
      departmentList: []
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  mounted: function mounted() {
    if (this.notEmployees == '未入职') {
      this.isViewSearch = false;
      this.search = [{
        field_name: '姓名/手机号',
        field_name_en: 'search',
        form_value: 'input'
      }, {
        field_name: '员工性别',
        field_name_en: 'sex',
        form_value: 'select',
        data_dict: this.sexOptions
      }, {
        field_name: '学历',
        field_name_en: 'education',
        form_value: 'select',
        data_dict: this.educationOptions
      }];
    } else if (this.notEmployees == '在职') {
      this.isViewSearch = true;
      this.search = [{
        field_name: '姓名/手机号',
        field_name_en: 'search',
        form_value: 'input'
      }, {
        field_name: '选择部门',
        field_name_en: 'frame_id',
        form_value: 'frame_id',
        data_dict: []
      }, {
        field_name: '入职时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }];
      this.viewSearch[0].options = this.sexOptions;
      this.viewSearch[1].options = this.educationOptions;
    } else {
      this.isViewSearch = true;
      this.search = [{
        field_name: '姓名/手机号',
        field_name_en: 'search',
        form_value: 'input'
      }, {
        field_name: '选择部门',
        field_name_en: 'frame_id',
        form_value: 'frame_id',
        data_dict: []
      }, {
        field_name: '离职时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }];
      this.viewSearch[0].options = this.sexOptions;
      this.viewSearch[1].options = this.educationOptions;
      this.viewSearch.splice(2, 2);
    }
  },
  methods: {
    dropdownFn: function dropdownFn(data) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(data.value == 1)) {
                _context.next = 5;
                break;
              }
              _this.tableFrom.exportType = 1;
              _this.confirmData();
              _context.next = 14;
              break;
            case 5:
              if (!(data.value == 2)) {
                _context.next = 9;
                break;
              }
              _this.$refs.importExcel.btnClick();
              _context.next = 14;
              break;
            case 9:
              if (!(data.value == 3)) {
                _context.next = 14;
                break;
              }
              _context.next = 12;
              return getTemp();
            case 12:
              result = _context.sent;
              _this.fileLinkDownLoad(result.data.url, '员工档案导入模板.xlsx');
            case 14:
              _this.tableFrom.exportType = 0;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 导入
    importExcelData: function importExcelData(data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var tabtypes, res, newData, i, isType, isPart, isGender, isEducation, _data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              tabtypes = localStorage.getItem('tabTypes');
              res = [];
              newData = data;
              if (!(newData.length <= 0)) {
                _context2.next = 7;
                break;
              }
              _this2.$message.error('批量导出内容为空');
              _context2.next = 29;
              break;
            case 7:
              i = 0;
            case 8:
              if (!(i <= newData.length - 1)) {
                _context2.next = 25;
                break;
              }
              if (!(newData[i][0] === '')) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("continue", 22);
            case 13:
              isType = {
                正式: 1,
                试用: 2,
                实习: 3,
                离职: 4
              };
              newData[i][5] = isType[newData[i][5]] || 0;
              isPart = {
                兼职: 1,
                全职: 0,
                实习: 2,
                劳务派遣: 3,
                退休返聘: 4,
                劳务外包: 5,
                其他: 6
              };
              newData[i][4] = isPart[newData[i][4]] || 0;
              isGender = {
                男: 1,
                女: 2
              };
              newData[i][1] = isGender[newData[i][1]] || 0;
              isEducation = {
                研究生: 6,
                本科: 5,
                专科: 4,
                高中及以下: 2
              };
              newData[i][2] = isEducation[newData[i][2]] || 2;
              res.push({
                name: newData[i][0],
                sex: newData[i][1],
                education: newData[i][2],
                phone: newData[i][3],
                is_part: newData[i][4],
                type: newData[i][5],
                position: '',
                frames: '',
                card_id: newData[i][6]
              });
            case 22:
              i++;
              _context2.next = 8;
              break;
            case 25:
              _data = {
                type: tabtypes,
                data: res
              };
              _context2.next = 28;
              return importCardApi(_data);
            case 28:
              _this2.handleConfirm();
            case 29:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 导出上传模板
    exportTemplate: function exportTemplate() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getTemp();
            case 2:
              result = _context3.sent;
              _this3.fileLinkDownLoad(result.data.url, '员工档案导入模板.xlsx');
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 新增
    openDrawer: function openDrawer() {
      this.$emit('opendrawer', true);
    },
    getExportExcel: function getExportExcel() {
      this.$refs.exportExcel.exportExcel();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.$emit('confirmData', {});
      } else {
        this.$emit('confirmData', data);
      }
    }
  }
};